import api from "./api";

/**
 * Service cho Sổ Theo Dõi Chi Tiết Vốn Đầu Tư Chủ Sở Hữu (S51-DN)
 * API: /detailed-ledger-owners-capital
 */
const DetailedLedgerOwnersCapitalService = {
  /**
   * Tạo sổ mới
   */
  create: async (payload) => {
    return api.post("private/detailed-ledger-owners-capital", payload);
  },

  /**
   * Lấy danh sách phân trang + filter
   * @param {Object} params - {page, size, year?, sortBy, sortType}
   */
  paginate: async (params = {}) => {
    return api.get("private/detailed-ledger-owners-capital/paginate", { params });
  },

  /**
   * Lấy chi tiết sổ theo ID
   */
  getById: async (id) => {
    return api.get(`private/detailed-ledger-owners-capital/${id}`);
  },

  /**
   * Cập nhật sổ
   */
  update: async (id, payload) => {
    return api.patch(`private/detailed-ledger-owners-capital/${id}`, payload);
  },

  /**
   * Xóa sổ
   */
  remove: async (id) => {
    return api.delete(`private/detailed-ledger-owners-capital/${id}`);
  },

  /**
   * Khởi tạo data mẫu
   */
  init: async () => {
    return api.post("private/detailed-ledger-owners-capital/init");
  },
};

export { DetailedLedgerOwnersCapitalService };
